module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/portfolio-single-2-514e15fd32bb758783a0349ef532bac9.jpg";